import { type MutableRefObject, useCallback, useEffect } from 'react'
import { useBlocker } from 'react-router-dom'

export const useUnsavedChangesGuard = (isDirty: boolean, isSubmitting: boolean, bypassRef?: MutableRefObject<boolean>) => {
  const shouldGuard = useCallback(() => isDirty && !isSubmitting && !bypassRef?.current, [isDirty, isSubmitting, bypassRef])

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (shouldGuard()) {
        event.preventDefault()
      }
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [shouldGuard])

  const blocker = useBlocker(({ currentLocation, nextLocation }) => shouldGuard() && currentLocation.pathname !== nextLocation.pathname)

  return {
    isBlocked: blocker.state === 'blocked',
    confirmLeave: () => blocker.proceed?.(),
    cancelLeave: () => blocker.reset?.(),
  }
}
